import FormHelperText from '@mui/material/FormHelperText';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import * as React from 'react';
import { Controller } from 'react-hook-form';
import { inputStyle } from '../../utils/formStyle';
import { FormInputLabel } from './FormInputLabel';

export const FormDatePicker = React.forwardRef((props, ref) => {
  const { label, error, control, rules, ...rest } = props;
  return (
    <div className='flex flex-col gap-1'>
      {label && <FormInputLabel label={label} isRequired={rest.required} />}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          control={control}
          name={rest.name}
          rules={rules || (rest.required ? { required: true } : undefined)}
          render={({ field }) => {
            return (
              <DatePicker
                sx={{
                  '.MuiInputBase-root': inputStyle,
                }}
                {...field}
                {...rest}
                error={!!error && field.value}
              />
            );
          }}
        />
      </LocalizationProvider>
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
});

FormDatePicker.displayName = 'FormDatePicker';
